import { formatDecimal, formatMs, NO_VALUE, ratio } from '../../lib/format.ts'
import type { LatencyMs } from '../../lib/sse/types.ts'
import { LatencySpine } from '../charts/LatencySpine.tsx'
import { Metric } from '../primitives/Metric.tsx'
import { Panel } from '../primitives/Panel.tsx'

/** p99/p50 above this stops being a tail and starts being a queue somewhere. */
const SPREAD_WARN = 12
const SPREAD_CRIT = 30

export function LatencyPanel({
  latency,
  className,
}: {
  latency: LatencyMs | null
  className?: string
}) {
  const spread = latency === null ? null : ratio(latency.p99, latency.p50)
  const spreadTone =
    spread === null ? 'neutral' : spread >= SPREAD_CRIT ? 'crit' : spread >= SPREAD_WARN ? 'warn' : 'neutral'

  return (
    <Panel
      title="Latência ponta a ponta"
      className={className}
      meta={<span>agente → persistido</span>}
    >
      <div className="flex h-full flex-col gap-2">
        <div className="grid grid-cols-4 gap-2">
          <Metric label="p50" value={formatMs(latency?.p50)} />
          <Metric label="p95" value={formatMs(latency?.p95)} />
          <Metric label="p99" value={formatMs(latency?.p99)} size="lg" tone="accent" />
          <div>
            <span className="text-micro uppercase tracking-label text-fg-muted">dispersão p99/p50</span>
            <div className="mt-0.5 flex items-baseline gap-1">
              <span
                className={`live-value font-mono text-base ${
                  spreadTone === 'crit' ? 'text-crit' : spreadTone === 'warn' ? 'text-warn' : 'text-fg'
                }`}
              >
                {spread === null ? NO_VALUE : `${formatDecimal(spread, 1)}×`}
              </span>
            </div>
          </div>
        </div>

        <LatencySpine latency={latency} />
      </div>
    </Panel>
  )
}
